import { render, staticRenderFns } from "./customerAccount.vue?vue&type=template&id=7ddc9852&scoped=true"
import script from "./customerAccount.vue?vue&type=script&lang=js"
export * from "./customerAccount.vue?vue&type=script&lang=js"
import style0 from "./customerAccount.vue?vue&type=style&index=0&id=7ddc9852&prod&scoped=true&lange=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc9852",
  null
  
)

export default component.exports